"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableFooterCell = exports.TableFooterRow = exports.TableFooterElement = exports.TableHeaderSortIndicator = exports.TableHeaderText = exports.TableHeaderCell = exports.TableHeaderRow = exports.TableHeaderElement = exports.FixedHeaderDiv = exports.ScrollDiv = exports.TableText = exports.TableRow = exports.TableCell = exports.TableBody = exports.TableElement = exports.ResizeCellGrip = exports.SubField = exports.MayOverflow = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _tokens = require("../../../tokens");

var _tooltip = require("../../atoms/tooltip");

var _resizeGrip = _interopRequireDefault(require("./_resize-grip"));

var _index = require("./index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  padding: 12px ", ";\n  box-sizing: border-box;\n  border-bottom: ", ";\n  text-align: left;\n  vertical-align: bottom;\n  background-color: #f4f5f6;\n  font-weight: 700;\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  font-family: Proxima-Nova-Semibold;\n  cursor: ", ";\n  pointer-events: ", ";\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  padding-left: ", ";\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 12px ", ";\n  box-sizing: border-box;\n  border-bottom: ", ";\n  text-align: left;\n  vertical-align: bottom;\n  min-width: 104px;\n  max-width: 560px;\n  &:last-child {\n    ", " {\n      display: none;\n    }\n  }\n  ", ";\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    background: ", ";\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n      background: ", ";\n      &:hover {\n        background: ", ";\n      }\n      &:active {\n        background: ", ";\n      }\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border-right: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  font-family: Proxima-Nova-Regular;\n  color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  padding: 13px ", " 12px ", ";\n  border-top: 1px solid ", ";\n  text-align: left;\n  vertical-align: middle;\n  line-height: 2;\n  box-sizing: border-box;\n  cursor: ", ";\n  background: ", ";\n  text-align: ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    width: 100%;\n    display: block;\n  }\n  cursor: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  border-bottom: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      position: absolute;\n      z-index: 36;\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  table-layout: fixed;\n  border-spacing: 0;\n  border-collapse: collapse;\n  ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n  overflow: scroll;\n  overflow-x: hidden;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MayOverflow = _styledComponents["default"].div(_templateObject());

exports.MayOverflow = MayOverflow;
var SubField = MayOverflow.extend(_templateObject2(), function (props) {
  return (0, _index.getColors)(props).subText;
});
exports.SubField = SubField;

var ScrollDiv = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.height || '400px';
});

exports.ScrollDiv = ScrollDiv;

var TableElement = _styledComponents["default"].table(_templateObject4(), function (props) {
  return props.fixedHeader && (0, _styledComponents.css)(_templateObject5());
});

exports.TableElement = TableElement;

var TableBody = _styledComponents["default"].tbody(_templateObject6(), function (props) {
  return !props.footerFields && props.bottomBorder && "1px solid ".concat((0, _index.getColors)(props).cellBorder);
});

exports.TableBody = TableBody;

var TableRow = _styledComponents["default"].tr(_templateObject7(), _tooltip.ContentTooltip, function (props) {
  return props.selectable ? 'pointer' : 'default';
});

exports.TableRow = TableRow;

var TableCell = _styledComponents["default"].td(_templateObject8(), _tokens.spacing.small, _tokens.spacing.small, function (props) {
  return (0, _index.getColors)(props).cellBorder;
}, function (props) {
  return props.clickable && 'default';
}, function (props) {
  return props.resizing ? (0, _index.getColors)(props).resizingBackground : null;
}, function (props) {
  return props.column.align || 'left';
});

exports.TableCell = TableCell;

var TableText = _styledComponents["default"].span(_templateObject9(), function (props) {
  return (0, _index.getColors)(props).text;
});

exports.TableText = TableText;

var getResizeStyle = function getResizeStyle(props) {
  var borderStyle;
  if (props.resizeHover) borderStyle = 'solid';else if (props.resizeStart) borderStyle = 'dotted';else if (props.resizeStop) borderStyle = 'none';
  return {
    borderStyle: borderStyle
  };
};

var ResizeCellGrip = _styledComponents["default"].span(_templateObject10(), function (props) {
  return props.resizeHover || props.resizeStart ? "1.4px ".concat(getResizeStyle(props).borderStyle, " ").concat((0, _index.getColors)(props).resizingBorder) : null;
});

exports.ResizeCellGrip = ResizeCellGrip;

var FixedHeaderDiv = _styledComponents["default"].div(_templateObject11());
/* Table header elements starts*/


exports.FixedHeaderDiv = FixedHeaderDiv;

var getHeaderStyles = function getHeaderStyles(props) {
  if (props.headerHover) {
    return (0, _styledComponents.css)(_templateObject12(), function (props) {
      return (0, _index.getColors)(props).headerBackground;
    }, function (props) {
      return (0, _index.getColors)(props).headerHoverBackground;
    }, function (props) {
      return (0, _index.getColors)(props).headerActiveBackground;
    });
  }

  return (0, _styledComponents.css)(_templateObject13(), function (props) {
    return (0, _index.getColors)(props).headerBackground;
  });
};

var TableHeaderElement = _styledComponents["default"].thead(_templateObject14());

exports.TableHeaderElement = TableHeaderElement;

var TableHeaderRow = _styledComponents["default"].tr(_templateObject15());

exports.TableHeaderRow = TableHeaderRow;

var TableHeaderCell = _styledComponents["default"].th(_templateObject16(), _tokens.spacing.small, function (props) {
  return "".concat(props.headerBorder, " solid ").concat((0, _index.getColors)(props).headerBorder);
}, _resizeGrip["default"], function (props) {
  return getHeaderStyles(props);
});

exports.TableHeaderCell = TableHeaderCell;

var TableHeaderSortIndicator = _styledComponents["default"].span(_templateObject17(), _tokens.spacing.xsmall);

exports.TableHeaderSortIndicator = TableHeaderSortIndicator;

var TableHeaderText = _styledComponents["default"].span(_templateObject18(), function (props) {
  return props.column.sortable || props.column.sort ? 'pointer' : 'auto';
}, function (props) {
  return props.column.sortable || props.column.sort ? 'auto' : 'none';
});
/* table footer Elements Start */


exports.TableHeaderText = TableHeaderText;

var TableFooterElement = _styledComponents["default"].tfoot(_templateObject19());

exports.TableFooterElement = TableFooterElement;

var TableFooterRow = _styledComponents["default"].tr(_templateObject20());

exports.TableFooterRow = TableFooterRow;

var TableFooterCell = _styledComponents["default"].td(_templateObject21(), _tokens.spacing.small, function (props) {
  return "".concat(props.headerBorder, " solid ").concat((0, _index.getColors)(props).headerBorder);
});
/* table footer Elements End */


exports.TableFooterCell = TableFooterCell;